import React, {useEffect, useRef, useState} from 'react'
import {Box, Card, Grid} from '@material-ui/core';
import './TableAndForm.css'
import FormPanel from './Components/AddEditForm/AddEditForm'
import {
    addMilestoneTemplateRequest,
    addTagRequest,
    addTasklistTemplateRequest,
    addTaskUnderTasklistTemplateRequest,
    deleteMilestoneRequestTemplate,
    deleteTasklistRequestTemplate,
    deleteTaskRequestTemplate,
    editMilestoneTemplateRequest,
    editTaskListOfProjectTemplateRequest,
    editTaskUnderTasklistTemplateRequest,
    getAllMilestoneOfTemplate,
    getAllMilestonesRequest,
    getAllTagsRequset,
    getAllTasklistOfTemplate,
    getMilestoneDetails,
    getPrdecessorListOfTemplateRequest,
    getTaskDetailsRequest,
    getTasklistDetailsRequest,
    getTasksUnderTaskListProjectTemplateRequest,
    getUnAssociatedTasklistForTemplate,
    taskOrderRequestTemplate
} from '../../../../ConfigurationApiActions'
import {connect} from 'react-redux';
import {useParams} from 'react-router';
import AppHeader from '../../../../../userDashboard/components/AppHeader/AppHeader';
import TemplateHeader from './Components/TemplateHeader/TemplateHeader';
import LoaderForSaveAndEdit from '../../../../../../utilities/AppLoader/LoaderForSaveAndEdit'
import MessageModal from '../../../../../../utilities/MessageModal/MessageModal'
import TableView from './Components/TableView/TableView';

const priority = [
    {name: 'High', value: 1, id: '1'},
    {name: 'Medium', value: 2, id: '2'},
    {name: 'Low', value: 3, id: '3'}
]
const TableAndForm = ({
                               getUnAssociatedTasklistRequest,
                               deleteMilestoneRequest,
                               deleteTasklistRequest,
                               taskOrderRequest,
                               deleteTaskRequest,
                               addTags,
                               getAllTags,
                               getTaskDetails,
                               getMilestoneDetailsRequest,
                               getTasklistDetails,
                               handleDrawerOpenClose,
                               history,
                               match,
                               addMileStone,
                               getAllMilestones,
                               editMilestone,
                               addTasklist,
                               editTaskListOfProject,
                               addTaskUnderTasklistProject,
                               editTaskUnderTasklistProject,
                               getTemplateDataOfTasklist,
                               getTemplateDataOfMilestone,
                               getPrdecessorList
                           }) => {

    const {templateId} = useParams()
    const projectTemplateId = templateId ? templateId : ""
    const modalRef = useRef();

    const [hideTemplate, setHideTemplate] = useState('');

    const [hideTitle, setHideTitle] = useState(false);
    const [title, setTitle] = useState(null);
    const [prevTitle, setPrevTitle] = useState(null);
    const [description, setDescription] = useState(null);
    const [prevDescription, setPrevDescription] = useState(null);
    const [hideDescription, setHideDescription] = useState(false);
    const [chips, setChips] = useState([])
    const [prevChips, setPrevChips] = useState([])
    const [hideChipTitle, setHideChipTitle] = useState(false);
    const [assignArchitect, setAssignArchitect] = useState(null);
    const [showArchitect, setShowArchitect] = useState(false);
    const [assignApprover, setAssignApprover] = useState(null);
    const [showAssignApprover, setShowAssignApprover] = useState(false);
    const [showTasklistDropDown, setShowTasklistDropDown] = useState(false);
    const [allTaskList, setAllTaskList] = useState(null);
    const [selectedTaskList, setSelectedTaskList] = useState([])
    const [prevSelectedTaskList, setPrevSelectedTaskList] = useState([])

    const [approver, setApprover] = useState([
        {name: 'Yes', value: true, id: '1'},
        {name: 'No', value: false, id: '2'},
    ]);
    const [selectedApprover, setSelectedApprover] = useState(approver[1]);
    const [prevSelectedApprover, setPrevSelectedApprover] = useState(approver[1]);
    const [showApprovalDropdown, setShowApprovalDropdown] = useState(false);
    const [showChecklistDropdown, setShowChecklistDropdown] = useState(false);
    const [allCheckList, setAllCheckList] = useState(null);
    const [selectedChecklist, setSelectedChecklist] = useState(null);
    const [prevSelectedChecklist, setPrevSelectedChecklist] = useState(null);

    const [showMilestoneDropdown, setShowMilestoneDropdown] = useState(false)
    const [selectedMilestone, setSelectedMilestone] = useState(null);
    const [prevSelectedMilestone, setPrevSelectedMilestone] = useState(null);


    const [tasklistIndex, setTasklistIndex] = useState(null);
    const [taskIndex, setTaskIndex] = useState(null);
    const [milestoneIndex, setMilestoneIndex] = useState(null);

    const [predecessorList, setPredecessorList] = useState(null);
    const [selecetedPredecessor, setSelecetedPredecessor] = useState([])
    const [prevSelecetedPredecessor, setPrevSelecetedPredecessor] = useState([])

    const [isEditPredecessor, setIsEditPredecessor] = useState(false)
    const [templateData, setTemplateData] = useState([])

    const [selectedPriority, setSelectedPriority] = useState(priority[0]);
    const [prevSelectedPriority, setPrevSelectedPriority] = useState(priority[1]);
    const [showPriorityDropdown, setShowPriorityDropdown] = useState(false);
    const [slectedTaskForUnderTasklist, setSlectedTaskForUnderTasklist] = useState(null)
    const [onTaskFormSave, setOnTaskFormSave] = useState(false)
    const [fotStoreTaskName, setFotStoreTaskName] = useState(null)

    const [selectedRow, setSelectedRow] = useState(null);

    //for showing edit values
    const [isTasklistEditNames, setIsTasklistEditNames] = useState(null)
    const [isApprovalEdit, setIsApprovalEdit] = useState(null)
    const [isEditChecklistMilestone, setIsEditChecklistMilestone] = useState(null)
    const [taskSelectedCheckList, setTaskSelectedCheckList] = useState(null)
    const [isFormEdit, setIsFormEdit] = useState(false);

    const [isShowLoader, setIsShowLoader] = useState(false);
    const [idForDsiplalyLoader, setIdForDisplayLoader] = useState(null);

    const [allMilestones, setAllMilestones] = useState(null)
    const [arrayOfTasklistName, setArrayOfTasklistName] = useState(null)

    const [isRightPanelShow, setIsRightPanelShow] = useState(false)
    const [isMilestone, setIsMileStone] = useState(false)
    const [addUpdateRes, setAddUpdateRes] = useState({
        res: [],
        formName: ''
    });

    const [allTags, setAllTags] = useState(null)
    const [tagName, setTagName] = useState(null);

    useEffect(() => {
        if (tagName && tagName.length >= 3 && tagName.length < 4) {
            getAllTags(tagName, true).then((res) => {
                setAllTags(res)
            }).catch((err) => {
            })
        }
    }, [tagName])

    const getTasklistsAndMilestones = (tableView) => {
        if (tableView === "Milestone") {
            getTemplateDataOfMilestone(projectTemplateId, true).then((res) => {
                setTemplateData(res)
                // if (res.length > 0) {
                //     setHideTemplate('Milestone');
                // }
            })
        } else {
            getTemplateDataOfTasklist(projectTemplateId, false).then((res) => {
                setTemplateData(res)
                if (res && res.length > 0) {
                    setHideTemplate('Tasklist');
                }
            })
        }
    }

    useEffect(() => {
        if (isMilestone) {
            getTasklistsAndMilestones("Milestone");
        } else {
            getTasklistsAndMilestones("Tasklist");
        }
    }, [projectTemplateId, isMilestone])


    useEffect(() => {
        getPrdecessorList(projectTemplateId).then((res) => {
            setPredecessorList(res.dataList)
        })
    }, [addUpdateRes, onTaskFormSave])

    useEffect(() => {
        // get all milestones
        getAllMilestones(projectTemplateId).then((res) => {
            setAllMilestones(res)
        })
    }, [showMilestoneDropdown, addUpdateRes])

    useEffect(() => {
        if (hideTemplate === "Task") {
            getTemplateDataOfTasklist(projectTemplateId, true).then((res) => {
                setAllTaskList(res)
            })
        } else {
            getUnAssociatedTasklistRequest(projectTemplateId).then((res) => {
                setAllTaskList(res)
            })
        }
    }, [showTasklistDropDown, addUpdateRes, hideTemplate])

    useEffect(() => {
        let namesTasklist = [];
        if (isTasklistEditNames && isTasklistEditNames.length > 0) {
            getTemplateDataOfTasklist(projectTemplateId, true).then((res) => {
                // setAllTaskList(res)
                isTasklistEditNames && isTasklistEditNames.map((id) => {
                    let findNames = res && res.find((name) => name.id === id)
                    if (findNames) {
                        namesTasklist.push(findNames)
                    }
                    return id
                })
                let arr = [];
                namesTasklist.map((tasklist) => {
                    arr.push(tasklist.title)
                    return tasklist
                })
                setArrayOfTasklistName(arr)
            })
        } else {
            setArrayOfTasklistName([])
        }
    }, [isTasklistEditNames, selectedTaskList, isFormEdit])

    // add tags
    const addChips = (tags) => {
        tags.map((singleTagName) => {
            let data = {
                name: singleTagName,
                color: singleTagName
            }
            addTags(data).then((res) => {
            })
            return singleTagName
        })

    }

    // for tasklist
    const saveHandler = () => {
        if (tasklistIndex != null) {

            let data = {
                title: title,
                isApprovalNeeded: selectedApprover.name === "Yes"
            }
            if (selectedMilestone) {
                data.milestoneId = selectedMilestone.id
            } else {
            }
            if (description) {
                data.description = description
            } else {
            }
            if (selectedChecklist) {
                if (selectedChecklist === "None") {
                    data.checklistId = null
                } else {
                    data.checklistId = selectedChecklist.id
                }
            } else {
            }
            if (chips) {
                data.tags = chips
            } else {
            }

            editTaskListOfProject(data, tasklistIndex).then((res) => {
                // addChips(chips)
                let filterArr = []
                getAllTags().then((res) => {
                    let arr = chips && chips.filter((tag) => {
                        return !(res.some((resTag) => resTag.name === tag))
                    })
                    filterArr.push(arr)
                    addChips(filterArr[0])
                })
                setIsMileStone(false)
                setAddUpdateRes({
                    res: res,
                    formName: 'Tasklist'
                });

                // setShowTaskOfTasklist({});
                setTitle(res.title);
                setHideTitle(false);
                setDescription(res.description);
                setHideDescription(false);
                setChips(res.tags);
                setHideChipTitle(false);
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setShowApprovalDropdown(false)
                if (res.checklist && res.checklist.checklist === null) {
                    setSelectedChecklist(null)
                    setTaskSelectedCheckList(null)
                    setPrevSelectedChecklist(null)
                } else if (res.checklist) {
                    setSelectedChecklist(res.checklist)
                    setTaskSelectedCheckList(res.checklist)
                    setPrevSelectedChecklist(res.checklist)
                }
                setShowChecklistDropdown(false)
                let arrayMiliestone = allMilestones.find((milestone) => milestone.id === res.milestoneId)
                setSelectedMilestone(arrayMiliestone)
                setShowMilestoneDropdown(false)

                setIsFormEdit(true)
                setTasklistIndex(res.id)
                setSelectedRow(res.id)

            })

        } else {
            let data = {
                title: title,
                isApprovalNeeded: selectedApprover.name === "Yes",
                projectId: projectTemplateId
            }

            if (selectedMilestone) {
                data.milestoneId = selectedMilestone.id
            } else {
            }
            if (description) {
                data.description = description
            } else {
            }
            if (selectedChecklist) {
                data.checklistId = selectedChecklist.id
            } else {
            }
            if (chips) {
                data.tags = chips
            } else {
            }

            addTasklist(data).then((res) => {
                // addChips(chips)
                let filterArr = []
                getAllTags().then((res) => {
                    let arr = chips && chips.filter((tag) => {
                        return !(res.some((resTag) => resTag.name === tag))
                    })
                    filterArr.push(arr)
                    addChips(filterArr[0])
                })
                setIsMileStone(false)
                // setShowTaskOfTasklist({});
                setAddUpdateRes({
                    res: res,
                    formName: 'Tasklist'
                });
                setTitle(res.title);
                setHideTitle(false);
                setDescription(res.description);
                setHideDescription(false);
                setChips(res.tags);
                setHideChipTitle(false);
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setShowApprovalDropdown(false)
                setTaskSelectedCheckList(res.checklist);
                setShowChecklistDropdown(false)
                let arrayMiliestone = allMilestones.find((milestone) => milestone.id === res.milestoneId)
                setSelectedMilestone(arrayMiliestone)
                setShowMilestoneDropdown(false)

                setIsFormEdit(true)
                setTasklistIndex(res.id)
                setSelectedRow(res.id)
            })
                .catch((err) => {
                })

        }
    }

    // for task
    const saveTaskHandler = () => {

        if (taskIndex != null) {
            let data = {
                title: title,
                tasklistId: slectedTaskForUnderTasklist,
                isApprovalNeeded: selectedApprover.name === "Yes"
            }

            if (description) {
                data.description = description
            } else {
            }

            if (chips) {
                data.tags = chips
            } else {
            }

            if (selectedChecklist) {
                if (selectedChecklist === "None") {
                    data.checklistId = null
                } else {
                    data.checklistId = selectedChecklist.id
                }
            } else {
            }

            if (selectedPriority) {
                data.priority = selectedPriority.value
            } else {
            }

            if (selecetedPredecessor) {
                let arrayPredecessor = [];
                selecetedPredecessor.map((task) => arrayPredecessor.push(task.id))
                data.predecessors = arrayPredecessor
            } else {
            }

            if (slectedTaskForUnderTasklist) {
                data.tasklistId = slectedTaskForUnderTasklist.id
            }

            editTaskUnderTasklistProject(data, taskIndex).then((res) => {
                // addChips(chips)
                let filterArr = []
                getAllTags().then((res) => {
                    let arr = chips && chips.filter((tag) => {
                        return !(res.some((resTag) => resTag.name === tag))
                    })
                    filterArr.push(arr)
                    addChips(filterArr[0])
                })
                setAddUpdateRes({
                    res: res,
                    formName: 'Task'
                });
                let prev = onTaskFormSave
                setOnTaskFormSave(!prev)
                // setTasklistIndex(null)
                // setShowTaskOfTasklist({});

                setTaskIndex(res.id)
                setIsFormEdit(true)
                if (res.predecessors) {
                    let arrayPredecessor = predecessorList.filter((tasksList) => {
                        return (res.predecessors.find((data) => {
                                return data === tasksList.id
                            })
                        )
                    })
                    setSelecetedPredecessor(arrayPredecessor)
                }
                setTitle(res.title);
                setHideTitle(false);
                setDescription(res.description);
                setHideDescription(false);
                setChips(res.tags);
                setHideChipTitle(false);
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setShowApprovalDropdown(false)
                if (res.checklist && res.checklist.checklist === null) {
                    setSelectedChecklist(null)
                    setTaskSelectedCheckList(null)
                    setPrevSelectedChecklist(null)
                } else if (res.checklist) {
                    setSelectedChecklist(res.checklist)
                    setTaskSelectedCheckList(res.checklist)
                    setPrevSelectedChecklist(res.checklist)
                }
                setShowChecklistDropdown(false)
                let priorityArray = priority.find((priority) => priority.value === res.priority)
                setSelectedPriority(priorityArray)
                setShowPriorityDropdown(false)
                let tasklistArr = allTaskList.filter((tasklist) => tasklist.id === res.tasklistId)
                setSlectedTaskForUnderTasklist(tasklistArr[0])
                setShowTasklistDropDown(false)

                setIsEditPredecessor(true)
                setSelectedRow(res.id)
            })
            // setSlectedTaskForUnderTasklist(null)
            // setSelecetedPredecessor(null)

        } else {
            let data = {
                title: title,
                tasklistId: slectedTaskForUnderTasklist,
                isApprovalNeeded: selectedApprover.name === "Yes"
            }

            if (description) {
                data.description = description
            } else {
            }

            if (chips) {
                data.tags = chips
            } else {
            }

            if (selectedChecklist) {
                data.checklistId = selectedChecklist.id
            } else {
            }

            if (selectedPriority) {
                data.priority = selectedPriority.value
            } else {
            }

            if (selecetedPredecessor) {
                let arrayPredecessor = [];
                selecetedPredecessor.map((task) => arrayPredecessor.push(task.id))
                data.predecessors = arrayPredecessor
            } else {
            }

            addTaskUnderTasklistProject(data).then((res) => {
                // addChips(chips)
                let filterArr = []
                getAllTags().then((res) => {
                    let arr = chips && chips.filter((tag) => {
                        return !(res.some((resTag) => resTag.name === tag))
                    })
                    filterArr.push(arr)
                    addChips(filterArr[0])
                })
                setAddUpdateRes({
                    res: res,
                    formName: 'Task'
                });
                let prev = onTaskFormSave
                setOnTaskFormSave(!prev)
                // setTasklistIndex(null)
                // setShowTaskOfTasklist({});

                setTitle(res.title);
                setHideTitle(false);
                setDescription(res.description);
                setHideDescription(false);
                setChips(res.tags);
                setHideChipTitle(false);
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setShowApprovalDropdown(false)
                setTaskSelectedCheckList(res.checklist);
                setShowChecklistDropdown(false)
                let priorityArray = priority.find((priority) => priority.value === res.priority)
                setSelectedPriority(priorityArray)
                setShowPriorityDropdown(false)
                if (res.predecessors) {
                    let arrayPredecessor = predecessorList.filter((tasksList) => {
                        return (res.predecessors.find((data) => {
                                return data === tasksList.id
                            })
                        )
                    })
                    setSelecetedPredecessor(arrayPredecessor)
                }
                let tasklistArr = allTaskList.filter((tasklist) => tasklist.id === res.tasklistId)
                setSlectedTaskForUnderTasklist(tasklistArr[0])
                setShowTasklistDropDown(false)

                setIsFormEdit(true)
                setTaskIndex(res.id)

                setIsEditPredecessor(true)
                setSelectedRow(res.id)

            })
        }
    }

    // for milestone
    const saveHandlerMilestone = () => {
        if (milestoneIndex != null) {

            let data = {
                title: title,
                isApprovalNeeded: selectedApprover.name === "Yes"
            }
            if (description) {
                data.description = description
            } else {
            }
            if (chips) {
                data.tags = chips
            } else {
            }
            if (selectedTaskList) {
                let tasklistArrya = [];
                selectedTaskList.map((tasklist) => tasklistArrya.push(tasklist.id))
                data.tasklists = tasklistArrya
            } else {
            }
            if (selectedChecklist) {
                if (selectedChecklist === "None") {
                    data.checklistId = null
                } else {
                    data.checklistId = selectedChecklist.id
                }
            } else {
            }

            editMilestone(data, milestoneIndex).then((res) => {

                // addChips(chips)
                let filterArr = []
                getAllTags().then((res) => {
                    let arr = chips && chips.filter((tag) => {
                        return !(res.some((resTag) => resTag.name === tag))
                    })
                    filterArr.push(arr)
                    addChips(filterArr[0])
                })

                setIsMileStone(true)
                setAddUpdateRes({
                    res: res,
                    formName: 'Milestone'
                });
                let tasklistArray = [];
                res.tasklists && res.tasklists.map((tasklist) => tasklistArray.push(tasklist.id))
                if (tasklistArray.length > 0) {
                    setIsTasklistEditNames(tasklistArray)
                }
                setTitle(res.title);
                setHideTitle(false);
                setDescription(res.description);
                setHideDescription(false);
                setChips(res.tags);
                setHideChipTitle(false);
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setShowApprovalDropdown(false)
                if (res.tasklists) {
                    setSelectedTaskList(res.tasklists)
                }

                setShowTasklistDropDown(false)
                if (res.checklist && res.checklist.checklist === null) {
                    setSelectedChecklist(null)
                    setTaskSelectedCheckList(null)
                    setPrevSelectedChecklist(null)
                } else if (res.checklist) {
                    setSelectedChecklist(res.checklist)
                    setTaskSelectedCheckList(res.checklist)
                    setPrevSelectedChecklist(res.checklist)
                }
                setShowChecklistDropdown(false)

                setIsFormEdit(true)
                setMilestoneIndex(res.id)
                setSelectedRow(res.id)
            })


        } else {
            let data = {
                projectId: projectTemplateId,
                title: title,
                isApprovalNeeded: selectedApprover.name === "Yes",
            }

            if (description) {
                data.description = description
            } else {
            }
            if (chips) {
                data.tags = chips
            } else {
            }
            if (selectedTaskList) {
                let tasklistArrya = [];
                selectedTaskList.map((tasklist) => tasklistArrya.push(tasklist.id))
                data.tasklists = tasklistArrya
            } else {
            }
            if (selectedChecklist) {
                data.checklistId = selectedChecklist.id
            } else {
            }

            addMileStone(data).then((res) => {

                // addChips(chips)
                let filterArr = []
                getAllTags().then((res) => {
                    let arr = chips && chips.filter((tag) => {
                        return !(res.some((resTag) => resTag.name === tag))
                    })
                    filterArr.push(arr)
                    addChips(filterArr[0])
                })

                setIsMileStone(true)
                setAddUpdateRes({
                    res: res,
                    formName: 'Milestone'
                });
                let tasklistArray = [];
                res.tasklists && res.tasklists.map((tasklist) => tasklistArray.push(tasklist.id))
                if (tasklistArray.length > 0) {
                    setIsTasklistEditNames(tasklistArray)
                }
                if (res.tasklists) {
                    setSelectedTaskList(res.tasklists)
                }
                setTitle(res.title);
                setDescription(res.description);
                setChips(res.tags);
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setTaskSelectedCheckList(res.checklist);

                setShowChecklistDropdown(false)
                setHideTitle(false);
                setHideDescription(false);
                setHideChipTitle(false);
                setShowApprovalDropdown(false)
                setShowTasklistDropDown(false)


                setIsFormEdit(true)
                setMilestoneIndex(res.id)

                setSelectedRow(res.id)

            }).catch((err) => {
            })
            // setTitle('')
            // setDescription('')
            // setChips([])
            // setSelectedApprover(approver[1])
            // setSelectedTaskList([])
            // setSelectedChecklist(null)
        }

    }

    const onCancelTaskFormHandler = () => {
        setHideTemplate('Tasklist');
        setHideTitle(false);
        setHideDescription(false);
        setHideChipTitle(false);
        setTaskIndex(null)
        setTasklistIndex(null)
        setMilestoneIndex(null)
        setTitle('');
        setDescription('');
        setChips([])
        setShowTasklistDropDown(false)
        setShowApprovalDropdown(false)
        setShowChecklistDropdown(false)
        setShowMilestoneDropdown(false)
        setShowPriorityDropdown(false)
        setSelectedTaskList([])
        setSelectedApprover(approver[1])
        setSelectedChecklist(null)
        setSelectedMilestone(null)
        setSelectedPriority(2)
        setSelecetedPredecessor(null)
    }

    const editHandler = () => {
        setHideTitle(true);
        setHideDescription(true);
        setHideChipTitle(true);
        if (hideTemplate === 'Task') {
            setShowTasklistDropDown(true)
        } else {
            setShowTasklistDropDown(true)
        }
        setShowApprovalDropdown(true)
        setShowChecklistDropdown(true)
        setShowMilestoneDropdown(true)
        setShowPriorityDropdown(true)

        setIsEditPredecessor(false)
    }

    const handleEsc = (e) => {
        if (e.keyCode === 27) {
            // for milestone

            if (hideTemplate === "Milestone" && milestoneIndex != null) {
                if (title === prevTitle && description === prevDescription && chips === prevChips && selectedApprover === prevSelectedApprover && selectedTaskList === prevSelectedTaskList && selectedChecklist === prevSelectedChecklist) {
                    setIsRightPanelShow(false)
                    setSelectedRow(null)
                } else {
                    const title = `Close Without Saving?`
                    const message = `Are you sure you want to close this edit milestone without saving?`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setIsRightPanelShow(false)
                            setSelectedRow(null)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });

                }
            } else if (hideTemplate === "Milestone") {
                if (title !== '' || description !== '' || chips.length > 0 || selectedTaskList !== '' || selectedChecklist !== null) {

                    const title = `Close Without Saving?`
                    const message = `Are you sure you want to close this milestone without saving?`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setIsRightPanelShow(false)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });
                } else {
                    setIsRightPanelShow(false)
                }
            } else {
            }

            // for tasklist

            if (hideTemplate === "Tasklist" && tasklistIndex != null) {
                if (title === prevTitle && description === prevDescription && chips === prevChips && selectedMilestone === prevSelectedMilestone && selectedChecklist === prevSelectedChecklist && selectedApprover === prevSelectedApprover) {
                    setIsRightPanelShow(false)
                    setSelectedRow(null)
                } else {
                    const title = `Close Without Saving?`
                    const message = `Are you sure you want to close this edit tasklist without saving?`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setIsRightPanelShow(false)
                            setSelectedRow(null)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });

                }
            } else if (hideTemplate === "Tasklist") {
                if (title !== '' || description !== '' || chips.length > 0 || selectedMilestone !== null || selectedChecklist !== null) {

                    const title = `Close Without Saving?`
                    const message = `Are you sure you want to close this tasklist without saving?`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setIsRightPanelShow(false)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });

                } else {
                    setIsRightPanelShow(false)
                }
            } else {
            }

            // for task

            if (hideTemplate === "Task" && taskIndex != null) {
                if (title === prevTitle && description === prevDescription && chips === prevChips && selectedChecklist === prevSelectedChecklist && selectedApprover === prevSelectedApprover && selecetedPredecessor === prevSelecetedPredecessor && selectedPriority === prevSelectedPriority) {
                    setIsRightPanelShow(false)
                    setSelectedRow(null)
                } else {

                    const title = `Close Without Saving?`
                    const message = `Are you sure you want to close this edit task without saving?`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setIsRightPanelShow(false)
                            setSelectedRow(null)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });

                }
            } else if (hideTemplate === "Task") {
                if (title !== '' || description !== '' || chips.length > 0 || selectedChecklist !== null || selecetedPredecessor !== null) {

                    const title = `Close Without Saving?`
                    const message = `Are you sure you want to close this task without saving?`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setIsRightPanelShow(false)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });

                } else {
                    setIsRightPanelShow(false)
                }
            } else {
            }
        }
    }

    const orderingRowHandler = (listName, taskObj, overlapTaskObj, isTasklistOpen) => {
        if (listName === "task") {
            if (isTasklistOpen) {

            } else {
                if (taskObj && overlapTaskObj && taskObj.tasklistId && overlapTaskObj.tasklistId && taskObj.tasklistId === overlapTaskObj.tasklistId) {
                    let data = {
                        tasklistId: taskObj.tasklistId,
                        taskId: taskObj.id,
                        belowTaskId: overlapTaskObj.id
                    }
                    taskOrderRequest(data)
                } else if (taskObj && overlapTaskObj && taskObj.tasklistId && overlapTaskObj.tasklistId && taskObj.tasklistId !== overlapTaskObj.tasklistId) {
                    let data = {
                        tasklistId: overlapTaskObj.tasklistId,
                        taskId: taskObj.id,
                        belowTaskId: overlapTaskObj.id
                    }
                    taskOrderRequest(data)
                } else if (taskObj && overlapTaskObj && !overlapTaskObj.tasklistId && overlapTaskObj.id === taskObj.tasklistId) {
                    let data = {
                        tasklistId: taskObj.tasklistId,
                        taskId: taskObj.id,
                        belowTaskId: null
                    }
                    taskOrderRequest(data)
                } else if (taskObj && overlapTaskObj && !overlapTaskObj.tasklistId && overlapTaskObj.id !== taskObj.tasklistId) {
                    let data = {
                        tasklistId: overlapTaskObj.id,
                        taskId: taskObj.id,
                        belowTaskId: null
                    }
                    taskOrderRequest(data)
                }
            }
        }
    }

    const toggleTableView = (setMergedTasks, setShowTaskOfTasklist) => {
        let prev = isMilestone
        setIsMileStone(!prev)
        setShowTaskOfTasklist({});
        setSelectedRow('')
        setMergedTasks([])
        createViewPanel()
    }

    const showTaskDetailsPane = (id, rightPane) => {
        if (rightPane === "Tasklist") {
            setIsFormEdit(true)

            getTasklistDetails(id).then((res) => {

                setHideTemplate('Tasklist')
                setHideTitle(false);
                setHideDescription(false);
                setHideChipTitle(false);
                setShowMilestoneDropdown(false)
                getAllMilestones(projectTemplateId).then((milestoneRes) => {
                    let arrayMiliestone = milestoneRes.find((milestone) => milestone.id === res.milestoneId)
                    setSelectedMilestone(arrayMiliestone)
                    setPrevSelectedMilestone(arrayMiliestone)
                })


                setTitle(res.title);
                setPrevTitle(res.title);
                setDescription(res.description);
                setPrevDescription(res.description);
                setChips(res.tags)
                setPrevChips(res.tags)

                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setPrevSelectedApprover(approverArray)
                setIsApprovalEdit(Boolean(res.isApprovalNeeded))

                setShowApprovalDropdown(false)
                if (res.checklist && res.checklist.checklist === null) {
                    setSelectedChecklist(null)
                    setTaskSelectedCheckList(null)
                    setPrevSelectedChecklist(null)
                } else if (res.checklist) {
                    setSelectedChecklist(res.checklist)
                    setTaskSelectedCheckList(res.checklist)
                    setPrevSelectedChecklist(res.checklist)
                } else {
                    setSelectedChecklist(null)
                    setTaskSelectedCheckList(null)
                    setPrevSelectedChecklist(null)
                }
                setShowChecklistDropdown(false)

                setIsShowLoader(false)
                setIdForDisplayLoader(null)

            })
        } else if (rightPane === "Milestone") {
            setIsFormEdit(true)
            getMilestoneDetailsRequest(id).then((res) => {
                setHideTemplate('Milestone')
                setHideTitle(false);
                setHideDescription(false);
                setHideChipTitle(false);
                setTitle(res.title);
                setPrevTitle(res.title);
                setDescription(res.description);
                setPrevDescription(res.description);
                setChips(res.tags)
                setPrevChips(res.tags)
                setShowTasklistDropDown(false)
                getTemplateDataOfTasklist(projectTemplateId, true).then((resForTasklist) => {
                    let tasklistArray = resForTasklist && resForTasklist.filter((tasklist) => {
                        return (res.tasklists.find((id) => {
                                return id === tasklist.id
                            })
                        )
                    })
                    setSelectedTaskList(tasklistArray)
                    setPrevSelectedTaskList(tasklistArray)
                })
                if (res.tasklists.length > 0) {
                    setIsTasklistEditNames(res.tasklists || [])
                } else {
                    setIsTasklistEditNames(res.tasklists || [])
                }
                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setPrevSelectedApprover(approverArray)
                setShowApprovalDropdown(false)
                if (res.checklist && res.checklist.checklist === null) {
                    setSelectedChecklist(null)
                    setPrevSelectedChecklist(null)
                } else if (res.checklist) {
                    setSelectedChecklist(res.checklist)
                    setPrevSelectedChecklist(res.checklist)
                } else {
                    setSelectedChecklist(null)
                    setPrevSelectedChecklist(null)
                }
                setShowChecklistDropdown(false)
                setIsShowLoader(false)
                setIdForDisplayLoader(null)
            })
        } else if (rightPane === "Task") {
            setIsFormEdit(true)

            getTaskDetails(id).then((res) => {

                setHideTemplate('Task')
                setHideTitle(false);
                setHideDescription(false);
                setHideChipTitle(false);
                setTitle(res.title);
                setPrevTitle(res.title);
                setDescription(res.description);
                setPrevDescription(res.description);
                setChips(res.tags)
                setPrevChips(res.tags)


                setShowTasklistDropDown(false)
                getTemplateDataOfTasklist(projectTemplateId, true).then((tasklistRes) => {
                    setAllTaskList(tasklistRes)
                    let tasklistArr = tasklistRes.filter((tasklist) => tasklist.id === res.tasklistId)
                    setSlectedTaskForUnderTasklist(tasklistArr[0])
                    setFotStoreTaskName(tasklistArr[0].title)
                })


                let approverArray = approver.find((approval) => approval.value === res.isApprovalNeeded)
                setSelectedApprover(approverArray)
                setPrevSelectedApprover(approverArray)
                setIsApprovalEdit(Boolean(res.isApprovalNeeded))
                setShowApprovalDropdown(false)

                if (res.checklist && res.checklist.checklist === null) {
                    setSelectedChecklist(null)
                    setTaskSelectedCheckList(null)
                    setPrevSelectedChecklist(null)
                } else if (res.checklist) {
                    setSelectedChecklist(res.checklist)
                    setTaskSelectedCheckList(res.checklist)
                    setPrevSelectedChecklist(res.checklist)
                } else {
                    setSelectedChecklist(null)
                    setPrevSelectedChecklist(null)
                }

                setShowChecklistDropdown(false)
                let priorityArray = priority.find((priority) => priority.value === res.priority)
                setSelectedPriority(priorityArray)
                setPrevSelectedPriority(priorityArray)

                setShowPriorityDropdown(false)
                if (res.predecessors && res.predecessors.dataList) {
                    setSelecetedPredecessor(res.predecessors.dataList)
                    setPrevSelecetedPredecessor(res.predecessors.dataList)
                } else {
                    setSelecetedPredecessor([])
                    setPrevSelecetedPredecessor([])
                }

                setIsShowLoader(false)
                setIdForDisplayLoader(null)
                setIsEditPredecessor(true)

            })
        }
    }
    console.log(taskSelectedCheckList)
    const createViewPanel = (rightPane, id = 1, title = "") => {
        setHideTitle(false);
        setHideDescription(false);
        setHideChipTitle(false);
        setTitle('');
        setDescription('');
        setChips([])
        setTaskIndex(null)
        setMilestoneIndex(null)
        setShowTasklistDropDown(false)
        setShowApprovalDropdown(false);
        setShowChecklistDropdown(false);
        setShowMilestoneDropdown(false)
        setShowPriorityDropdown(false)
        setSelectedTaskList([])
        setSelectedApprover(approver[1]);
        setIsApprovalEdit(Boolean(false))
        setSelectedChecklist(null)
        setSelectedMilestone(null)
        setSelectedPriority(priority[1])
        setSelecetedPredecessor(null)
        setIsFormEdit(false)
        setIsEditPredecessor(false)
        // setSelectedRow(null)
        setIsRightPanelShow(true)
        if (rightPane === "Tasklist") {
            setHideTemplate('Tasklist');
            setTasklistIndex(null)
        } else if (rightPane === "Milestone") {
            setHideTemplate('Milestone');
            setTasklistIndex(null)
        } else if (rightPane === "Task") {
            setHideTemplate('Task');
            setTasklistIndex(id)
            setPrevSelectedApprover(approver[1]);
            // setSlectedTaskForUnderTasklist(null)
            setSlectedTaskForUnderTasklist(id)
            setFotStoreTaskName(title)
        }
    }

    const deleteForm = (formName) => {
        if (formName === "Tasklist") {
            const title = `Delete tasklist`
            const message = `Deleting this tasklist will also delete all the linked tasks with corresponding conversations, timelogs and activity details. Are you sure you want to proceed?`
            modalRef.current.setState({
                showModal: true,
                message: message,
                title: title,
                showOkButton: true,
                showCancelButton: true,
                showNote: false,
                note: '',
                handleOk: (note) => {
                    // alert(tasklistIndex)
                    deleteTasklistRequest(tasklistIndex).then((res) => {
                        setIsRightPanelShow(false)
                        let data = {
                            isDelete: true,
                            taskId: tasklistIndex
                        }
                        setAddUpdateRes({
                            res: data,
                            formName: 'Tasklist'
                        });
                    })
                },
                okText: "Yes",
                cancelText: 'No'
            });
        } else if (formName === "Milestone") {
            const title = `Delete milestone`
            const message = `Are you sure you want to proceed?`
            modalRef.current.setState({
                showModal: true,
                message: message,
                title: title,
                showOkButton: true,
                showCancelButton: true,
                showNote: false,
                note: '',
                handleOk: (note) => {
                    // alert(milestoneIndex)
                    deleteMilestoneRequest(milestoneIndex).then((res) => {
                        setIsRightPanelShow(false)
                        let data = {
                            isDelete: true,
                            milestoneId: milestoneIndex
                        }
                        setAddUpdateRes({
                            res: data,
                            formName: 'Milestone'
                        });
                    })
                },
                okText: "Yes",
                cancelText: 'No'
            });
        } else if (formName === "Task") {
            const title = `Delete task`
            const message = `Deleting this task will also delete all the linked conversations, timelogs and activity details. Are you sure you want to proceed?`
            modalRef.current.setState({
                showModal: true,
                message: message,
                title: title,
                showOkButton: true,
                showCancelButton: true,
                showNote: false,
                note: '',
                handleOk: (note) => {
                    deleteTaskRequest(taskIndex)
                    setIsRightPanelShow(false)
                    let data = {
                        isDelete: true,
                        taskId: taskIndex
                    }
                    setAddUpdateRes({
                        res: data,
                        formName: 'Task'
                    });
                },
                okText: "Yes",
                cancelText: 'No'
            });
        }
    }

    return (
        <>

            <AppHeader handleDrawerOpenClose={handleDrawerOpenClose}>
                <TemplateHeader history={history} match={match}/>
            </AppHeader>

            <Box>
                <Grid container>
                    <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                        <Card
                            className={hideTemplate ? 'card-table-on-btn-click table-view-tasklist-container' : "card-table-view-container"}
                        > <TableView
                            showTaskDetailsPane={showTaskDetailsPane}
                            history={history}
                            getTasklistsAndMilestones={getTasklistsAndMilestones}
                            createViewPanel={createViewPanel}
                            toggleTableView={toggleTableView}
                            orderingRowHandler={orderingRowHandler}
                            setIsMileStone={setIsMileStone}
                            isMilestone={isMilestone}
                            setIsRightPanelShow={setIsRightPanelShow}
                            selectedRow={selectedRow}
                            setSelectedRow={setSelectedRow}
                            setTasklistIndex={setTasklistIndex}
                            setTaskIndex={setTaskIndex}
                            setMilestoneIndex={setMilestoneIndex}
                            templateData={templateData}
                            isShowLoader={isShowLoader}
                            setIsShowLoader={setIsShowLoader}
                            idForDsiplalyLoader={idForDsiplalyLoader}
                            setIdForDisplayLoader={setIdForDisplayLoader}
                            addUpdateRes={addUpdateRes}
                            setAddUpdateRes={setAddUpdateRes}
                        />
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                        <Card
                            className={hideTemplate ? isShowLoader ? 'add-update-form' :  isRightPanelShow ? 'add-update-form-onclick for-padding-bottom-10' : "" :''}
                        >
                            {
                                hideTemplate
                                    ?
                                    <>
                                        {
                                            isShowLoader
                                                ?
                                                <span
                                                    className="loader-for-save-and-edit"><LoaderForSaveAndEdit/></span>
                                                :
                                                <>
                                                    {
                                                        isRightPanelShow
                                                            ?
                                                            <FormPanel setTagName={setTagName} allTags={allTags}
                                                                       deleteForm={deleteForm}
                                                                       selectedChecklist={selectedChecklist}
                                                                       handleEsc={handleEsc}
                                                                       isEditPredecessor={isEditPredecessor}
                                                                       setArrayOfTasklistName={setArrayOfTasklistName}
                                                                       arrayOfTasklistName={arrayOfTasklistName}
                                                                       allMilestones={allMilestones}
                                                                       setAllMilestones={setAllMilestones}
                                                                       setIsFormEdit={setIsFormEdit}
                                                                       isFormEdit={isFormEdit} editHandler={editHandler}
                                                                       selectedRow={selectedRow}
                                                                       isEditChecklistMilestone={isEditChecklistMilestone}
                                                                       setIsEditChecklistMilestone={setIsEditChecklistMilestone}
                                                                       isApprovalEdit={isApprovalEdit}
                                                                       isTasklistEditNames={isTasklistEditNames}
                                                                       fotStoreTaskName={fotStoreTaskName}
                                                                       templateData={templateData}
                                                                       onCancelTaskFormHandler={onCancelTaskFormHandler}
                                                                       taskIndex={taskIndex}
                                                                       projectId={projectTemplateId}
                                                                       slectedTaskForUnderTasklist={slectedTaskForUnderTasklist}
                                                                       setSlectedTaskForUnderTasklist={setSlectedTaskForUnderTasklist}
                                                                       setShowPriorityDropdown={setShowPriorityDropdown}
                                                                       showPriorityDropdown={showPriorityDropdown}
                                                                       setSelectedPriority={setSelectedPriority}
                                                                       selectedPriority={selectedPriority}
                                                                       priority={priority}
                                                                       setSelectedMilestone={setSelectedMilestone}
                                                                       selectedMilestone={selectedMilestone}
                                                                       showMilestoneDropdown={showMilestoneDropdown}
                                                                       setShowMilestoneDropdown={setShowMilestoneDropdown}
                                                                       setTaskSelectedCheckList={setSelectedChecklist}
                                                                       taskSelectedCheckList={selectedChecklist}
                                                                       setAllCheckList={setAllCheckList}
                                                                       allCheckList={allCheckList}
                                                                       setShowChecklistDropdown={setShowChecklistDropdown}
                                                                       showChecklistDropdown={showChecklistDropdown}
                                                                       showApprovalDropdown={showApprovalDropdown}
                                                                       setShowApprovalDropdown={setShowApprovalDropdown}
                                                                       setSelectedApprover={setSelectedApprover}
                                                                       selectedApprover={selectedApprover}
                                                                       setApprover={setApprover} approver={approver}
                                                                       setSelectedTaskList={setSelectedTaskList}
                                                                       selectedTaskList={selectedTaskList}
                                                                       allTaskList={allTaskList}
                                                                       setAllTaskList={setAllTaskList}
                                                                       showTasklistDropDown={showTasklistDropDown}
                                                                       setShowTasklistDropDown={setShowTasklistDropDown}
                                                                       setShowAssignApprover={setShowAssignApprover}
                                                                       showAssignApprover={showAssignApprover}
                                                                       setAssignApprover={setAssignApprover}
                                                                       assignApprover={assignApprover}
                                                                       showArchitect={showArchitect}
                                                                       setShowArchitect={setShowArchitect}
                                                                       assignArchitect={assignArchitect}
                                                                       setAssignArchitect={setAssignArchitect}
                                                                       setSelecetedPredecessor={setSelecetedPredecessor}
                                                                       selecetedPredecessor={selecetedPredecessor}
                                                                       setPredecessorList={setPredecessorList}
                                                                       predecessorList={predecessorList}
                                                                       saveHandlerMilestone={saveHandlerMilestone}
                                                                       tasklistIndex={tasklistIndex}
                                                                       saveTaskHandler={saveTaskHandler}
                                                                       saveHandler={saveHandler}
                                                                       setHideChipTitle={setHideChipTitle}
                                                                       hideChipTitle={hideChipTitle} setChips={setChips}
                                                                       chips={chips}
                                                                       setHideDescription={setHideDescription}
                                                                       hideDescription={hideDescription}
                                                                       setDescription={setDescription}
                                                                       description={description} title={title}
                                                                       setTitle={setTitle} hideTitle={hideTitle}
                                                                       setHideTitle={setHideTitle}
                                                                       hideTemplate={hideTemplate}
                                                                       setHideTemplate={setHideTemplate}/>
                                                            :
                                                            <></>
                                                    }
                                                </>
                                        }
                                    </>
                                    // <FormPanel setArrayOfTasklistName={setArrayOfTasklistName} arrayOfTasklistName={arrayOfTasklistName} allMilestones={allMilestones} setAllMilestones={setAllMilestones} setIsFormEdit={setIsFormEdit} isFormEdit={isFormEdit} editHandler={editHandler} selectedRow={selectedRow} isEditChecklistMilestone={isEditChecklistMilestone} setIsEditChecklistMilestone={setIsEditChecklistMilestone} isApprovalEdit={isApprovalEdit} isTasklistEditNames={isTasklistEditNames} fotStoreTaskName={fotStoreTaskName} templateData={templateData} onCancelTaskFormHandler={onCancelTaskFormHandler} taskIndex={taskIndex}   projectId={projectTemplateId} slectedTaskForUnderTasklist={slectedTaskForUnderTasklist} setSlectedTaskForUnderTasklist={setSlectedTaskForUnderTasklist} setShowPriorityDropdown={setShowPriorityDropdown} showPriorityDropdown={showPriorityDropdown} setSelectedPriority={setSelectedPriority} selectedPriority={selectedPriority} priority={priority} setSelectedMilestone={setSelectedMilestone} selectedMilestone={selectedMilestone} showMilestoneDropdown={showMilestoneDropdown} setShowMilestoneDropdown={setShowMilestoneDropdown} setTaskSelectedCheckList={setSelectedChecklist} taskSelectedCheckList={selectedChecklist} setAllCheckList={setAllCheckList} allCheckList={allCheckList} setShowChecklistDropdown={setShowChecklistDropdown} showChecklistDropdown={showChecklistDropdown}  showApprovalDropdown={showApprovalDropdown} setShowApprovalDropdown={setShowApprovalDropdown} setSelectedApprover={setSelectedApprover} selectedApprover={selectedApprover} setApprover={setApprover} approver={approver} setSelectedTaskList={setSelectedTaskList} selectedTaskList={selectedTaskList} allTaskList={allTaskList} setAllTaskList={setAllTaskList} showTasklistDropDown={showTasklistDropDown} setShowTasklistDropDown={setShowTasklistDropDown} setShowAssignApprover={setShowAssignApprover} showAssignApprover={showAssignApprover} setAssignApprover={setAssignApprover} assignApprover={assignApprover} showArchitect={showArchitect} setShowArchitect={setShowArchitect} assignArchitect={assignArchitect} setAssignArchitect={setAssignArchitect} setSelecetedPredecessor={setSelecetedPredecessor} selecetedPredecessor={selecetedPredecessor} setPredecessorList={setPredecessorList} predecessorList={predecessorList} saveHandlerMilestone={saveHandlerMilestone} tasklistIndex={tasklistIndex} saveTaskHandler={saveTaskHandler} saveHandler={saveHandler} setHideChipTitle={setHideChipTitle} hideChipTitle={hideChipTitle} setChips={setChips} chips={chips} setHideDescription={setHideDescription} hideDescription={hideDescription} setDescription={setDescription} description={description} title={title} setTitle={setTitle} hideTitle={hideTitle} setHideTitle={setHideTitle} hideTemplate={hideTemplate} setHideTemplate={setHideTemplate}/>
                                    :
                                    <></>
                            }
                        </Card>
                    </Grid>
                </Grid>
            </Box>
            <MessageModal
                ref={modalRef}/>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        // loggedInUser: state.auth.loggedInUser,
        // post: state.postDetails.post,
        // comments:state.postDetails.comments
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        addMileStone: (data) => {
            return dispatch(addMilestoneTemplateRequest(data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getAllMilestones: (projectId) => {
            return dispatch(getAllMilestonesRequest(projectId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        editMilestone: (data, milestoneId) => {
            return dispatch(editMilestoneTemplateRequest(data, milestoneId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        addTasklist: (data) => {
            return dispatch(addTasklistTemplateRequest(data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        editTaskListOfProject: (data, tasklistId) => {
            return dispatch(editTaskListOfProjectTemplateRequest(data, tasklistId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getTaskOfTasklistProject: (tasklistId) => {
            return dispatch(getTasksUnderTaskListProjectTemplateRequest(tasklistId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getPrdecessorList: (templateId) => {
            return dispatch(getPrdecessorListOfTemplateRequest(templateId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        addTaskUnderTasklistProject: (data) => {
            return dispatch(addTaskUnderTasklistTemplateRequest(data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        editTaskUnderTasklistProject: (data, taskId) => {
            return dispatch(editTaskUnderTasklistTemplateRequest(data, taskId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getTemplateDataOfTasklist: (templateId, forHideLoader, isAssociate, data) => {
            return dispatch(getAllTasklistOfTemplate(templateId, forHideLoader, isAssociate, data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getUnAssociatedTasklistRequest: (templateId) => {
            return dispatch(getUnAssociatedTasklistForTemplate(templateId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getTemplateDataOfMilestone: (templateId, forHideLoader) => {
            return dispatch(getAllMilestoneOfTemplate(templateId, forHideLoader)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getTasklistDetails: (tasklistId) => {
            return dispatch(getTasklistDetailsRequest(tasklistId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getMilestoneDetailsRequest: (milestoneId) => {
            return dispatch(getMilestoneDetails(milestoneId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getTaskDetails: (taskId) => {
            return dispatch(getTaskDetailsRequest(taskId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getAllTags: (name, searchTag) => {
            return dispatch(getAllTagsRequset(name, searchTag)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        addTags: (data) => {
            return dispatch(addTagRequest(data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        deleteTaskRequest: (taskId) => {
            return dispatch(deleteTaskRequestTemplate(taskId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        taskOrderRequest: (data) => {
            return dispatch(taskOrderRequestTemplate(data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        deleteTasklistRequest: (tasklistId) => {
            return dispatch(deleteTasklistRequestTemplate(tasklistId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        deleteMilestoneRequest: (tasklistId) => {
            return dispatch(deleteMilestoneRequestTemplate(tasklistId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(TableAndForm);
